import React from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle, Divider, Button,
} from '@material-ui/core';

function DialogBox(props) {
  const {
    onClose, open, title, confirm, data, children,
  } = props;
  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <Divider />
      <DialogContent>
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          No
        </Button>
        <Button onClick={() => { return confirm(data); }} color="primary" autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogBox;
